// components/Address/SubLabelField.js
import React from 'react';

const SubLabelField = ({
  value,
  onChange,
  readOnly,
  isReadOnly,
  handleHeadingFocus
}) => (
  <input
    className=""
    placeholder={'یک SubLabel وارد کنید'}
    style={{
      border: 'none',
      outline: 'none',
      userSelect: 'text',
      wordWrap: 'break-word',
      whiteSpace: 'pre-wrap',
      width: '100%',
      fontSize: '12px',
      fontWeight: 700,
      lineHeight: 1.45,
      color: '#b8bdc9',
    }}
    readOnly={isReadOnly || readOnly}
    value={value}
    onChange={onChange}
    onFocus={isReadOnly ? null : handleHeadingFocus}
  />
);

export default SubLabelField;
